var map = {
	"./modules/InfoScreens/components/EventRow/translations/default.json": 87785,
	"./modules/InfoScreens/components/Header/translations/default.json": 14982,
	"./modules/InfoTerminal/components/translations/default.json": 89971,
	"./modules/common/ErrorReporting/translations/default.json": 38666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92342;